import styled from 'styled-components';

export const UserOwnProductListDetailCardGroup = styled.div`
  display: flex;
  padding: 8px 16px 32px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
`;

export const UserOwnProductDetailCardWrapper = styled.div`
  display: flex;
  padding: 24px 0px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;

  border-bottom: 1px solid var(--Light-Scheme-Monochrome-grey20, #ececf3);

  :last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
`;
